export default {
  meta: {
    title: '租户管理详情'
  }
};
